export default __webpack_public_path__ + "static/media/profilepic.bcae9c8d.jpg";